/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsmodeown3Inputs */

const en_listingbuttonsmodeown3 = /** @type {(inputs: Listingbuttonsmodeown3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose yourself`)
};

const de_listingbuttonsmodeown3 = /** @type {(inputs: Listingbuttonsmodeown3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selbst wählen`)
};

/**
* | output |
* | --- |
* | "Choose yourself" |
*
* @param {Listingbuttonsmodeown3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmodeown3 = /** @type {((inputs?: Listingbuttonsmodeown3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmodeown3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmodeown3(inputs)
	return de_listingbuttonsmodeown3(inputs)
});
export { listingbuttonsmodeown3 as "listingButtonsModeOwn" }